import React from 'react'
import * as Styles from './styles'
import SvgLogoGrafeno from '../../../assets/svg-logo-grafeno'

interface Props {
  logo?: string | boolean
  svg?: object
}

const Logo: React.FC<Props> = (props: Props): JSX.Element => {
  return (
    <Styles.Logo>
      {!props.svg && props.logo && (
        <Styles.WrapperImage>
          <SvgLogoGrafeno />
        </Styles.WrapperImage>
      )}
      {props.svg && <Styles.WrapperImage>{props.svg}</Styles.WrapperImage>}
    </Styles.Logo>
  )
}

export default Logo
